import React from 'react';

import { Text } from './text';
import { cn } from './utils';

import type { TextProps, TextTagName } from './text';

export type CopyableTextProps<T extends TextTagName = 'span'> = TextProps<T> & {
  /** Text to copy. Defaults to children if children is a string/number. */
  textToCopy?: string;
  /** Callback after copy succeeds */
  onCopied?: () => void;
};

export const CopyableText = React.forwardRef(
  <T extends TextTagName>(
    { onClick, className, textToCopy, onCopied, children, ...rest }: CopyableTextProps<T>,
    ref: React.ForwardedRef<T>,
  ) => {
    const copyToClipboard = () => {
      const text = textToCopy ?? (typeof children === 'string' || typeof children === 'number' ? String(children) : undefined);
      if (!text) return;
      navigator.clipboard.writeText(text);
      onCopied?.();
    };

    return (
      <Text
        ref={ref}
        className={cn(className, 'cursor-pointer select-none')}
        onClick={(e: any) => {
          copyToClipboard();
          onClick?.(e);
        }}
        {...rest}
      >
        {children}
      </Text>
    );
  },
);

CopyableText.displayName = 'CopyableText';
